// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"776":"913ebe6b","798":"b6eca059"}[chunkId] + ".chunk.css";
};